import { render, staticRenderFns } from "./GenericStepCard.vue?vue&type=template&id=4bd841a5&scoped=true&"
import script from "./GenericStepCard.vue?vue&type=script&lang=js&"
export * from "./GenericStepCard.vue?vue&type=script&lang=js&"
import style0 from "./GenericStepCard.vue?vue&type=style&index=0&id=4bd841a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd841a5",
  null
  
)

export default component.exports